/**
 * /colocare — migrated from public/js/collocation.js.
 * 1. .layer-1 .col a.order-btn — hover toggle .icon-h
 * 2. Focus / blur pe input/textarea — .lb-focused pe parent label
 * 3. .plans accordion (li > a → slideToggle)
 * 4. #request-form — Form() (no-op via shim daca form-ul are method=post+action)
 */
import { Resort } from '../core/resort.js';

new Resort((rt) => {
    /* Order button hover */
    ($('.layer-1 .col a.order-btn', true) as NodeListOf<Element>).on('mouseover', function (this: Element) {
        const icon = this.parentElement?.find('.icon') as Element | null;
        if (icon && !icon.classList.contains('icon-h')) icon.classList.add('icon-h');
    });
    ($('.layer-1 .col a.order-btn', true) as NodeListOf<Element>).on('mouseout', function (this: Element) {
        const icon = this.parentElement?.find('.icon') as Element | null;
        if (icon?.classList.contains('icon-h')) icon.classList.remove('icon-h');
    });

    /* Inputs focus/blur */
    $('input[type="text"], textarea', true).on('focus', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p && !p.classList.contains('lb-focused')) p.classList.add('lb-focused');
    });
    $('input[type="text"], textarea', true).on('blur', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p?.classList.contains('lb-focused')) p.classList.remove('lb-focused');
    });

    /* Plans accordion */
    ($('.plans') as Element | null)?.on('click', 'li > a', function (this: Element) {
        this.classList.toggle('opened');
        (this.parents('li') as Element | null)?.find('ul')?.slideToggle();
    });

    /* Request form — submit nativ catre /message/send (Form() devine no-op via shim) */
    const is_en = /\/en\//.test(window.location.href);
    const rForm = $('#request-form') as HTMLFormElement | null;
    if (rForm) {
        rForm.Form('form', 'collocation_send_request', {}, {
            valid: () => ({
                company: 'min(5)max(40)',
                name:    'min(5)max(40)',
                email:   'mail(40)',
                phone:   'min(10)max(30)',
                message: 'nn()max(10000)',
            }),
            done: (r: unknown) => {
                if (r === 'Done') {
                    rForm.reset();
                    rt.notify(is_en ? 'Your request was sent successfully.' : 'Cererea ta a fost expediată cu succes.');
                }
            },
        });
    }
});
